import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../utils";
const badgeVariants = cva("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-normal transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2", {
    variants: {
        variant: {
            default: "border-white/20 bg-grayscale-medium text-white/[0.85] hover:border-white/[0.35]",
            secondary: "border-white/20 bg-grayscale-light text-white/[0.85] hover:border-white/[0.35]",
            destructive: "border-transparent bg-alert text-white hover:bg-alert/90",
            outline: "border-white/20 text-white/[0.85]",
            accent: "border-transparent bg-accent text-grayscale-darkest hover:bg-accent/90",
            dark: "border-white/20 bg-grayscale-dark text-white/[0.85] hover:border-white/[0.35]",
            darker: "border-white/20 bg-grayscale-darker text-white/[0.85] hover:border-white/[0.35]"
        }
    },
    defaultVariants: {
        variant: "default"
    }
});
function Badge({ className, variant, ...props }) {
    return /*#__PURE__*/ _jsx("div", {
        className: cn(badgeVariants({
            variant
        }), className),
        ...props
    });
}
export { Badge, badgeVariants };
